<template>
  <div>
    <c-row>
      <c-col col="12">
        <c-card>
          <loader v-show="loading" />
          <c-card-header>
            <strong>{{ title }}</strong>
            <div class="card-header-actions" v-show="isSearch">
              <CInput
                @keyup="doSearch"
                type="text"
                placeholder="Ketikan sesuatu kemudian tekan enter"
                v-model="q"
                style="width: 400px"
                ref="search"
              >
                <template #append-content>
                  <a @click="hideSearch">
                    <i class="cil-chevron-circle-right-alt"></i>
                  </a>
                </template>
              </CInput>
            </div>
            <div class="card-header-actions" v-show="!isSearch">
              <a class="link btn btn-outline-success" @click="addNew">
                <i class="cil-plus"></i>
              </a>
              <a class="link btn btn-outline-info" @click="showSearch">
                <i class="cil-search"></i>
              </a>
            </div>
          </c-card-header>
          <c-card-body style="overflow: auto">
            <table class="table table-bordered table-striped">
              <thead>
                <tr>
                  <th width="50px">No</th>
                  <th v-for="(d, k) in dataHeaders" :key="k">
                    <span
                      v-for="(fn, fk) in d"
                      :key="fk"
                      v-show="fk != 'align' && fk != 'type'"
                      >{{ fn }}</span
                    >
                  </th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(d, k) in data.data" :key="k">
                  <td class="center">
                    <table-number
                      :size="dataSize"
                      :page="currentPage"
                      :index="k"
                    />
                  </td>
                  <td v-for="(f, ky) in dataHeaders" :key="ky" :class="f.align">
                    <span v-if="f.date && f.date == 'date'">
                      <span v-for="(fn, fk) in f" :key="fk"
                        >{{ d[fk] | dateFormat }}
                      </span>
                    </span>
                    <span
                      v-else-if="f.date && f.date == 'datetime'"
                      v-for="(fn, fk) in f"
                      :key="fk"
                      >{{ d[fk] | dateTimeFormat }}</span
                    >
                    <span v-else v-for="(fn, fk) in f" :key="fk + ky">
                      <span
                        v-if="fk == 'deleted_at' && d[fk]"
                        class="label bg-danger"
                      >
                        Terhapus
                      </span>
                      <span v-else v-html="d[fk]"></span>
                    </span>
                  </td>
                  <td class="center" width="80px">
                    <button
                      class="btn-outline-info btn btn-action"
                      v-c-tooltip.click="'Preview'"
                      @click="doPreview(d.id)"
                      v-if="previewUrl"
                    >
                      <i class="cil-magnifying-glass"></i>
                    </button>
                    <button
                      class="btn-outline-success btn btn-action"
                      @click="doApprove(d.id)"
                      v-if="approveUrl"
                      v-c-tooltip.click="'Approve'"
                    >
                      <i class="cil-check"></i>
                    </button>
                    <button
                      class="btn-outline-info btn btn-action"
                      @click="doPrint(d.id)"
                      v-if="printUrl"
                      v-c-tooltip.click="'Print'"
                    >
                      <i class="cil-print"></i>
                    </button>
                    <button
                      class="btn-outline-warning btn btn-action"
                      @click="doEdit(d.id)"
                      v-if="editRoute"
                      v-c-tooltip.click="'Edit'"
                    >
                      <i class="cil-pencil"></i>
                    </button>
                    <button
                      class="btn-outline-danger btn btn-action"
                      @click="doDelete(d)"
                      v-if="deleteEndpoint && !d.deleted_at"
                      v-c-tooltip.click="'Delete'"
                    >
                      <i class="cil-trash"></i>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </c-card-body>
          <c-card-footer>
            <paginator :paginator="data.paginate" @change="changePage" />
          </c-card-footer>
        </c-card>
      </c-col>
    </c-row>
    <CModal
      title="Delete Confirmation"
      size="sm"
      color="danger"
      :show.sync="deleteConfirm"
    >
      Yakin Akan menghapus data {{ deletedObject.name }}?
      <textarea
        placeholder="alasan dihapus (max: 200)"
        class="form-control"
        v-model="delReason"
        maxlength="200"
        v-if="deleteReason"
      />
      <template #footer>
        <CButton @click="deleteConfirm = false" color="danger">Batal</CButton>
        <CButton @click="runDelete" color="success">Yakin</CButton>
      </template>
    </CModal>
  </div>
</template>
<script>
import TableNumber from "./TableNumber";
import { HTTPAUTH } from "../lib/httplib";
import { showErrorMessage } from '../lib/helpers';
import Loader from './Loader.vue';
import Paginator from './Paginator.vue';

export default {
  name: "CardList",
  components: {
    TableNumber,
    Loader,
    Paginator
  },
  data () {
    return {
      currentPage: 1,
      total: 1,
      data: [],
      deleteConfirm: false,
      deletedObject: {},
      isSearch: false,
      q: "",
      loading: false,
      delReason: ''
    };
  },
  created () {
    const query = this.$route.query;
    if (query.search === "true") {
      this.isSearch = query.search;
    }
    if (query.q) {
      this.loadData(1, query.q);
      this.q = query.q;
      return;
    }
    this.loadData(1, "");
  },
  methods: {
    changePage (page) {
      this.loadData(page, '')
    },
    loadData (page, q) {
      this.loading = true
      this.currentPage = page;
      HTTPAUTH.get(
        this.dataUrl + `?q=${q}&page=${page}&size=${this.dataSize}`
      ).then(res => {
        this.data = res.data;
        this.loading = false
      }).catch(eres => {
        this.loading = false
        showErrorMessage(eres)
      });
    },
    addNew () {
      this.$router.push({ path: this.editRoute });
    },
    doEdit (id) {
      this.$router.push({ path: this.editRoute, query: { id: id } });
    },
    doDelete (o) {
      this.deletedObject = o;
      this.deleteConfirm = true;
    },
    runDelete () {
      HTTPAUTH.delete(`${this.deleteEndpoint}/${this.deletedObject.id}?r=${this.delReason}`)
        .then(() => {
          this.$toasted.success("Hapus data berhasil").goAway(3000);
          this.deleteConfirm = false;
          this.loadData(1, '');
          this.delReason = '';
        })
        .catch(eres => {
          this.$toasted.error(eres.response.statusText).goAway(3000);
          this.deleteConfirm = false;
          this.delReason = '';
        });
    },
    hideSearch () {
      this.isSearch = false;
      this.$router.push({ query: { search: false } });
      this.q = "";
      this.loadData(1, "");
    },
    showSearch () {
      this.isSearch = true;
      this.$router.push({ query: { search: true } });
    },
    doSearch (e) {
      if (e.keyCode === 13) {
        this.loadData(1, this.q);
        this.$router.push({ query: { search: true, q: this.q } });
      }
    },
    doPrint (id) {
      window.open("#" + this.printUrl + "/" + id, "_blank")
    },
    doApprove (id) {
      this.$router.push({ path: this.approveUrl + "/" + id })
    },
    doPreview (id) {
      const url = this.previewUrl.replace(":id:", id);
      this.$router.push({ path: url })
    }
  },
  props: [
    "title",
    "dataUrl",
    "dataSize",
    "dataHeaders",
    "editRoute",
    "deleteEndpoint",
    "deleteReason",
    "printUrl",
    "approveUrl",
    "previewUrl",
  ],
  watch: {
    currentPage (pageNext) {
      const query = this.$route.query;
      var q = "";
      if (query.q) {
        q = query.q;
      }
      this.loadData(pageNext, q);
    }
  }
};
</script>